import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from './../firebase-config';
import Spinner from '../components/Spinner';

export default function Talks() {
  const [talksData, setTalksData] = useState([]);
  const talksDocRef = collection(db, 'talks-data');
  const talksQuery = query(talksDocRef, orderBy("date"))
  const getTalksData = async () => {
    const querySnapshot = await getDocs(talksQuery);
    let d = [];
    querySnapshot.forEach((doc) => {
      return d.push({
        id: doc.id,
        data: doc.data(),
      });
    });
    setTalksData(d);
  };
  console.log(talksData);
  useEffect(() => {
    document.title = 'Dr. Nithin M | Talks';
    getTalksData();
  }, []);
  return (
    <section class='blog-section'>
      <div>
        <h2 class='section-title'>Talks</h2>
      </div>
      {talksData.length > 0 ? (
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <table class='table table-striped table-responsive'>
                <thead>
                  <tr>
                    <th scope='col'>#</th>
                    <th scope='col'>Date</th>
                    <th scope='col'>Title of webinar or lecture</th>
                    <th scope='col'>Venue</th>
                    <th scope='col'>Audience</th>
                  </tr>
                </thead>
                <tbody>
                  {talksData.map((talk, i) => {
                    return (
                      <tr>
                        <th scope='row'>{i + 1}</th>
                        <td>{talk['data']['date']}</td>
                        <td>{talk['data']['title']}</td>
                        <td>
                          {talk['data']['venue'].map((x, y) => {
                            if (y === 0) {
                              return (
                                <>
                                  <b>{x}, </b>
                                  <br />
                                </>
                              );
                            } else {
                              return <>{x}, </>;
                            }
                          })}
                        </td>
                        <td>{talk['data']['audience']}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </section>
  );
}
